import { restRequest } from '../rest/rest';
export class ProviderService {
    constructor(config) {
        this.providerListEndpoint = '/digital/v3/chat/api/provider/list';
        this.providerAvailabilityEndpoint = '/digital/v3/chat/api/provider/availability';
        this.config_ = config;
    }
    async getProviders(token) {
        if (this.config_.useMocks.getProviders) {
            return Promise.resolve([
                {
                    providerName: 'member-chatbot',
                    providerId: 'member-chatbot',
                },
                {
                    providerName: 'provider-chatbot',
                    providerId: 'provider-chatbot',
                },
            ]);
        }
        try {
            const providers = (await restRequest(`${this.config_.environment}${this.providerListEndpoint}`, 'GET', undefined, token));
            return providers;
        }
        catch (e) {
            const chatError = e;
            if (chatError && chatError.code) {
                throw chatError;
            }
            else {
                throw { code: 'METHOD_ERROR', message: 'Invalid response.' };
            }
        }
    }
    async getAvailability(token, providerId) {
        if (providerId.length < 1) {
            throw { code: 'METHOD_ERROR', message: 'Invalid provider identifier.' };
        }
        if (this.config_.useMocks.getAvailability) {
            return Promise.resolve({
                provider: {
                    providerName: `${providerId}-mock`,
                    providerId: providerId,
                },
                isAvailable: true,
                platformSettings: {
                    chatUrl: `${this.config_.environment}/digital/v3/chat/ws/platform`,
                    connectionTimeout: '5000',
                    reconnectionTimeout: '300',
                    pingInterval: '5000',
                    pingRetryLimit: '3',
                    acknowledgementTimeout: '5000',
                    closeChatTimeout: '5000',
                },
            });
        }
        try {
            const provider = (await restRequest(`${this.config_.environment}${this.providerAvailabilityEndpoint}/${providerId}`, 'GET', undefined, token));
            return provider;
        }
        catch (e) {
            const chatError = e;
            if (chatError && chatError.code) {
                throw chatError;
            }
            else {
                throw { code: 'METHOD_ERROR', message: 'Invalid response.' };
            }
        }
    }
}
//# sourceMappingURL=provider-service.js.map